export default __webpack_public_path__ + "static/media/herojp2.e9c2ad0f.jp2";